// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__20Ax5","footer":"ModalFilter_footer__1rXOP"};